export default {
  copyAddress: "تم نسخ العنوان.",
  copy: "تم النسخ",
  operationsPageDetails: [
    { to: "deposit", tooltip: "إيداع" },
    { to: "withdrawal", tooltip: "سحب" },
    { to: "exchange", tooltip: "تبادل" },
    { to: "transfer", tooltip: "تحويل" }
  ],
  deposit: {
    to: "deposit",
    title: "إيداع",
    historyOfDeposit: "تاريخ الإيداع",
    userNotVerify: {
      title: "أنت غير مؤكد",
      description: "أكمل التحقق الخاص بك لإيداع الريال",
      button: "أكمل التحقق"
    },
    category: {
      crypto: {
        networkType: "نوع الشبكة",
        networkTypeNotice: `نوع الشبكة يحدد الشبكة التي يجب إجراء التحويل عليها. لإكمال المعاملة بنجاح، يجب اختيار نفس الشبكة في المصدر والوجهة.`,
        address: "عنوان الشبكة {address}",
        warningText:
          "لإيداع {name_locale} إلى عنوانك، تأكد من استخدام العنوان و{extra_name} {name_locale}.",
        noAddress: "لا يمكن إيداع هذه العملة المشفرة حاليًا.",
        hintTitle: "فقط قم بإيداع {iso} إلى هذا العنوان.",
        hintDescription:
          "إرسال العملات غير {iso} إلى هذا العنوان قد يؤدي إلى فقدانها.",
        networkRequestBtn: "طلب عنوان الشبكة",
        warningTitle: "تحذير",
        warningText1:
          "لإيداع هذه العملة، تأكد من استخدام العنوان والمذكرة في نفس الوقت.",
        warningText2: "خلاف ذلك، سيتم فقدان أصولك.",
        acceptTermsText: "لقد قرأت وقبلت الشروط المذكورة أعلاه",
        confirmBtn: "تأكيد",
        copyAddress: "تم نسخ العنوان."
      },
      rial: {
        paymentMethod: "طريقة الإيداع",
        paymentType: [
          {
            id: 0,
            field: "online_payment",
            route: "online",
            name: "عبر الإنترنت"
          },
          {
            id: 3,
            field: "direct_payment",
            route: "direct-debit",
            name: "الشحن الفوري"
          },
          {
            id: 2,
            field: "offline_payment_with_identifier",
            route: "paymentID",
            name: "إيداع بمعرف"
          },
          {
            id: 1,
            field: "offline_payment",
            route: "offline",
            name: "غير متصل"
          }
        ],
        directDebit: {
          maxWithdrawText: "الحد اليومي: {amount} ريال",
          usageText: "المبلغ المستخدم: {amount} ريال",
          expireText: "تاريخ انتهاء العقد: {amount}",
          newAccountBtn: "إضافة حساب جديد",
          immediateChargeBtn: "الشحن الفوري",
          doNotHaveImmediateAccText: "لم تقم بعد بتفعيل حساب للشحن الفوري.",
          shaparakRule:
            "وفقًا للقواعد الجديدة لشابرك، لا يمكن أن يتجاوز إجمالي الدفع اليومي من خلال بوابات البنوك {amount} ريال. للمبالغ الأعلى، يمكنك بسهولة استخدام طرق الإيداع بمعرف أو الإيداع غير المتصل.",
          activateImmediateChargeBtn: "تفعيل الشحن الفوري",
          removeImmediateChargeText: "إزالة الشحن الفوري",
          cancelBtn: "إلغاء",
          acceptRemovingBtn: "تأكيد الإزالة",
          copy: "تم النسخ.",
          chooseBank: {
            maxWithdrawText: "الحد اليومي: {amount} ريال",
            continueBtn: "متابعة",
            cancelBtn: "إلغاء"
          },
          createContractForm: {
            activateWithdrawText: "تفعيل السحب المباشر من",
            maxAmountTrx: "الحد الأقصى للمعاملة",
            contractPreiod: "مدة العقد",
            cancelBtn: "إلغاء",
            addContractBtn: "إنشاء عقد",
            successDeposit: "تم إيداع الريال بنجاح.",
            bankName: "اسم البنك",
            depositAmount: "مبلغ الإيداع",
            trxNumber: "رقم المعاملة",
            dateTitle: "التاريخ والوقت",
            walletBtn: "المحفظة",
            unSuccessfullTrxText: "معاملة غير ناجحة",
            maxDailyRemainedText: "الحد اليومي المتبقي",
            immediateChargeBtn: "الشحن الفوري"
          },
          directDebitTable: {
            immediateChargeHistoryTitle: "تاريخ الشحن الفوري"
          }
        },
        offline: {
          accountListTitle: "عرض أرقام حسابات Excoino",
          notice: {
            title: "يرجى الملاحظة",
            description:
              "لإيداعات الريال غير المتصلة، تأكد من اتباع التعليمات أدناه؛ خلاف ذلك، سيتم تعليق معاملتك.",
            firstRule: "1) يجب أن تكون البطاقة البنكية أو الحساب باسمك.",
            secondRule:
              '2) عند إجراء دفع PAAYE و SATNA، تأكد من كتابة عبارة "تأدية ديون" في وصف الدفع.',
            thirdRule:
              "3) معرف الإيداع هو رقم هويتك الوطنية. تأكد من كتابته على إيصال البنك عند إجراء الإيداع في البنك.",
            badgeText:
              'لإيداعات بنك شهر، بالإضافة إلى كتابة معرف الإيداع، تأكد من كتابة الرقم "90" في قسم رمز المرجع عند زيارة البنك شخصيًا أو استخدام تطبيق بنك شهر.'
          },
          form: {
            title: "تسجيل معلومات الإيداع غير المتصل",
            amountInputLabel: "مبلغ الإيداع",
            amountInputValidation: "أدخل مبلغ الإيداع.",
            depositType: "نوع الإيداع",
            selectLabel: "في أي حساب قمت بالإيداع؟ | في أي بطاقة قمت بالإيداع؟",
            noResult: "لم يتم العثور على نتائج.",
            selectValidation: "اختر الحساب البنكي. | اختر البطاقة البنكية.",
            bankInputLabel: "البنك المصدر",
            bankInputValidation: "أدخل البنك المصدر.",
            trackingInputLabel: "رمز التتبع",
            trackingInputValidation: "أدخل رمز التتبع.",
            dateInputLabel: "تاريخ الإيداع",
            dateInputValidation: "اختر تاريخ الإيداع.",
            imageInputLabel: "صورة إيصال البنك",
            imageInputValidation: "حمل صورة إيصال البنك.",
            button: "إرسال"
          },
          offlineTable: {
            title: "تاريخ الإيداع غير المتصل بالريال",
            tableHeader: {
              paymentDate: "تاريخ الدفع",
              amount: "مبلغ الإيداع (ريال)",
              action: "الإجراء",
              bankName: "اسم البنك",
              referBankCode: "رقم المرجع البنكي",
              providerReferCode: "رقم مرجع المزود",
              status: "الحالة"
            }
          },
          accountList: {
            accountOwner: "اسم صاحب الحساب",
            accountNumber: "رقم الحساب",
            depositId: "معرف الإيداع",
            cardNumber: "رقم البطاقة"
          }
        },
        online: {
          warningDescription:
            "وفقًا للوائح شابرك، يرجى ملاحظة أن الحد الأقصى لإجمالي المبالغ اليومية المدفوعة عبر بوابات البنوك هو 250,000,000 ريال. إذا كنت بحاجة إلى إيداع مبالغ أكبر، يمكنك بسهولة استخدام ميزة الإيداع بمعرف. توفر هذه الطريقة تسريعًا في عملية الإيداع وزيادة أسرع في الرصيد مقارنة بالطرق غير المتصلة.",
          warningLink: "إيداع بمعرف",
          availableBalance: "رصيدك الحالي",
          amount: "مبلغ الإيداع",
          bankingPortal: "اختر بوابة الدفع",
          button: "تابع عملية إيداع الريال",
          minBalanceError: "الحد الأدنى للمبلغ المسموح به هو {min}.",
          maxBalanceError: "",
          maximumText: "الحد الأقصى",
          canNotBeLessAmount: "المبلغ لا يمكن أن يكون أقل من {amount} ريال",
          cardSelectionPlaceholder: "اختر البطاقة البنكية",
          addCard: "إضافة بطاقة",
          addNewCard: "إضافة بطاقة بنكية جديدة",
          feeInfo:
            "نظرًا لرسوم بعض البوابات، قد يكون المبلغ الذي تدفعه أعلى قليلاً من المبلغ المدخل. يرجى ملاحظة أن Excoino لا تتلقى أي جزء من هذه الرسوم."
        },
        paymentId: {
          checkDepositId:
            "قبل كل دفعة، تحقق من رقم IBAN ومعرف الإيداع. قد تكون مختلفة لكل دفعة.",
          watchGuideVideo: "شاهد فيديو الدليل",
          close: "إغلاق",
          receiveDepositId: "احصل على معرف الإيداع",
          depositId: "معرف الإيداع",
          requiredDepositId: "التسجيل عند الإيداع إلزامي.",
          paymentIdTable: {
            depositHistoryTitle: "تاريخ الإيداع بمعرف"
          }
        }
      }
    }
  },
  withdraw: {
    to: "withdrawal",
    title: "سحب",
    withdrawHistoryTitle: "تاريخ السحب",
    otp: {
      title: {
        text1: "لم تقم بعد بتفعيل",
        text2: ""
      },
      description: {
        text1: "لتعزيز الأمان أثناء سحب العملة المشفرة، تحتاج إلى تفعيل",
        text2: "من إعدادات الحساب."
      }
    },
    category: {
      crypto: {
        networkType: "نوع الشبكة",
        networkTypeNotice: `نوع الشبكة يحدد الشبكة التي يجب إجراء التحويل عليها. لإكمال المعاملة بنجاح، يجب اختيار نفس الشبكة في المصدر والوجهة.`,
        addressLabel: "العنوان",
        addNewAddress: "إضافة عنوان جديد",
        submitBtn: "تابع عملية سحب العملة المشفرة",
        inventory: "الرصيد القابل للسحب",
        transferFee: "رسوم التحويل",
        amountReceived: "المبلغ المستلم الصافي",
        warningText:
          "لسحب {name_locale} إلى عنوانك، تأكد من استخدام العنوان و{extra_name} {name_locale}.",
        noAddress: "لا يمكن سحب هذه العملة المشفرة حاليًا.",
        addressNotCorrect: "العنوان المدخل غير صحيح.",
        mobileValidate: {
          title: "تحتاج إلى تسجيل رقم هاتفك المحمول لسحب العملة المشفرة.",
          description:
            "لسحب العملة المشفرة، تحتاج إلى تسجيل رقم هاتفك المحمول. لتعزيز الأمان أثناء سحب العملة المشفرة، تحتاج إلى التحقق من رقم هاتفك المحمول. يرجى الذهاب إلى إعدادات الحساب والتحقق من رقم هاتفك المحمول، ثم المتابعة بعملية السحب."
        },
        setting: "إعدادات الحساب",
        doNotNeedExtraName: "لا حاجة لـ {extraName}",
        addAddressCard: {
          addNewAddress: "إضافة عنوان جديد",
          selectNetwork: "اختر الشبكة",
          title: "العنوان",
          walletAddress: "عنوان المحفظة",
          add: "إضافة"
        },
        cancelOrderCard: {
          areYouSure: "هل أنت متأكد أنك تريد الإلغاء؟",
          waitFor2Min: "إذا ألغيت، لن تتمكن من تسجيل عنوان جديد لمدة دقيقتين.",
          sureCancel: "نعم، ألغي",
          canecelation: "إلغاء الإلغاء"
        },
        deleteAddressCard: {
          deleteWalletAddress: "حذف عنوان المحفظة",
          areYouSure: "هل أنت متأكد أنك تريد حذف هذا العنوان؟",
          sureDelete: "نعم، احذفه",
          canecelation: "إلغاء الحذف"
        },
        extraFeeCard: {
          increasedFee: "تم زيادة رسوم طلبك",
          continueOrder: "موافق، تابع الطلب",
          cancel: "إلغاء الطلب"
        },
        otpCard: {
          confirmCodeTitle: "رمز التأكيد",
          enterCode:
            "لإضافة عنوان، يرجى إدخال الرمز المرسل إلى (<span class='font-Bold-14' >{phoneNumber}</span >).",
          receiveCodeAgain: "إعادة إرسال رمز التأكيد",
          continue: "متابعة",
          remainTime: "أعد إرسال الرمز خلال {second} ثوانٍ"
        },
        sendMobileCard: {
          securityConfirm: "تأكيد الأمان",
          areYouSure: "هل أنت متأكد أنك تريد حذف هذا العنوان؟",
          mobileNumber: "رقم الهاتف المحمول",
          continue: "متابعة"
        },
        tagCard: {
          useFrom: "استخدام {extraName}",
          useMemo:
            "لـ {typeOfTransaction} {name_locale}، تأكد من استخدام العنوان و{extra_name} {name_locale}.",
          understood: "فهمت"
        }
      },
      rial: {
        withdrawType: "نوع السحب",
        yourInventory: "رصيدك الحالي",
        withdrawLabel: "مبلغ السحب",
        shebaLabel: "رقم IBAN",
        cardNumberLabel: "رقم البطاقة",
        addShebaNumber: "إضافة رقم IBAN جديد",
        addCardNumber: "إضافة رقم بطاقة جديد",
        shebaNumberHint: "يرجى اختيار أو إضافة رقم IBAN المطلوب",
        cardNumberHint: "يرجى اختيار أو إضافة رقم البطاقة المطلوب",
        continueBtn: "تابع عملية سحب الريال",
        cardToCardText: "حاليًا، السحب عبر الإيداع بالبطاقة غير متاح.",
        authenticationTitle: "أنت غير مؤكد",
        authenticationDescription: "أكمل التحقق الخاص بك لسحب الريال",
        authenticationBtn: "أكمل التحقق",
        sendAgainBtn: "إعادة إرسال رمز التأكيد",
        receive: "ستستلم",
        accountName: "اسم صاحب الحساب",
        transactionStatus: "عرض حالة المعاملة",
        submitTime: "تاريخ ووقت التسجيل",
        mobileCodeText: {
          text1: "لتأكيد طلب السحب، يرجى إدخال الرمز المرسل إلى (",
          text2: ")."
        },
        rulesText: {
          text1: "بوضع هذا الطلب، أؤكد أنني قرأت وقبلت",
          excoinoLink: "قواعد Excoino",
          text2: "."
        },
        toWithdrawLessThan: "لسحب أقل من {amount} مليون تومان",
        fee: "الرسوم: 50,000 ريال",
        defineShaba:
          "لتسهيل وتسريع عملية السحب لأكثر من 100 مليون تومان، قم بتسجيل رقم IBAN مختلف لكل 100 مليون تومان.",
        increaseFee: "سيتم خصم رسوم قدرها 50,000 ريال لكل 500 مليون ريال.",
        depositToSheba: "إيداع إلى IBAN",
        depositToCard: "إيداع إلى البطاقة",
        depositToCardTitle:
          "إيداع فوري إلى البطاقة | للسحوبات أقل من 50 مليون تومان",
        shebaNotCorrect: "رقم IBAN المدخل غير صحيح."
      }
    }
  },
  exchange: {
    submitOrder: {
      endTime: "انتهت صلاحية إكمال هذا الطلب.",
      timeNotice: "وقت إكمال هذا الطلب",
      payment: "الدفع",
      received: "المستلم",
      wage: "رسوم التحويل",
      submit: "تأكيد وإنهاء",
      tryAgain: "إعادة المحاولة",
      successText: "تم تسجيل طلبك بنجاح.",
      transactionNumber: "رقم المعاملة",
      cancel: "العودة",
      goWallet: "اذهب إلى المحفظة",
      goTransaction: "اذهب إلى المعاملات"
    },
    to: "exchange",
    title: "تبادل",
    inventory: "الرصيد",
    youPay: "أنت تدفع",
    receive: "ستستلم",
    youPayModalTitle: "اختر عملة الدفع",
    youPayModalPlaceholder: "ابحث بالاسم أو الرمز...",
    receiveModalTitle: "اختر عملة الاستلام",
    receiveModalPlaceholder: "ابحث بالاسم أو الرمز...",
    btn: {
      half: "نصف",
      all: "الكل",
      min: "الحد الأدنى"
    },
    submit: "تقديم الطلب",
    symbol: "الرمز",
    property: "الملكية",
    currenciesAutoComplete: {
      searchPlaceholder: "ابحث بالاسم أو الرمز...",
      notFound: "لم يتم العثور على نتائج."
    },
    exchangeInput: {
      thereIsNoCoin: "لا توجد عملة متاحة",
      approximately: "تقریبا"
    },
    balanceNotEnough: "رصيد محفظتك غير كاف.",
    maxReceive: "الحد الأقصى للمبلغ المستلم هو {amount}.",
    minReceive: "الحد الأدنى للمبلغ المستلم هو {amount}."
  },
  transfer: {
    to: "transfer",
    title: "تحويل",
    transferHistoryTitle: "تاريخ التحويل",
    transferToMarket: "تحويل إلى سوق Excoino",
    acceptOrder: "",
    continueProcess: "تابع عملية التحويل",
    haveNotAcceptRules: "لم تقبل بعد قواعد سوق Excoino",
    acceptRulesText:
      "عزيزي المستخدم، لاستخدام سوق Excoino، يجب أولاً قبول شروط هذا القسم. للقيام بذلك، انتقل إلى قسم سوق Excoino، اقرأ ووافق على الشروط، ثم عد إلى هذه الصفحة لتحويل العملة المشفرة.",
    goToMarket: "اذهب إلى سوق Excoino",
    balanceNotEnought: "رصيد محفظتك غير كاف.",
    maxTransfer: "الحد الأقصى للمبلغ المحول هو {amount}.",
    minTransfer: "الحد الأدنى للمبلغ المحول هو {amount}.",
    confirmOrder:
      'بوضع هذا الطلب، أؤكد أنني قرأت وقبلت <a href="{url}" target="_blank" class="font-Bold-12 gray1--text crypto-link">قواعد Excoino</a>.'
  },
  routeQueryTypes: [
    {
      query: "IRR",
      tooltip: "ريال"
    },
    {
      query: "cryptoCurrency",
      tooltip: "عملة مشفرة"
    }
  ],
  excoinoRulesFirstPart: "بوضع هذه المعاملة، أؤكد أنني قرأت وقبلت",
  excoinoRulesLink: "قواعد Excoino",
  excoinoRulesSecondPart: "."
};
